import React from 'react'
import { CheckOutlined } from '@ant-design/icons'
import { Form, Input } from 'antd' // Import AntD form components
import './ChooseFeatures.css'
import ButtonBlack from 'components/design/Form/ButtonBlack/index'

const StepChooseFeatures = ({ nextStep, selectedFeatures, setSelectedFeatures, form }) => {
  const toggleSelect = key => {
    setSelectedFeatures(prev => (prev.includes(key) ? prev.filter(i => i !== key) : [...prev, key]))

    // Sync selectedFeatures into form field so validation works
    const updated = selectedFeatures.includes(key)
      ? selectedFeatures.filter(i => i !== key)
      : [...selectedFeatures, key]

    form.setFieldsValue({ features: updated })
  }

  const handleContinue = async () => {
    try {
      await form.validateFields(['features']) //  validates using AntD rules
      nextStep()
    } catch (error) {
      // AntD will show error message automatically
      console.log('Validation failed:', error)
    }
  }

  const features = [
    {
      key: 'chat',
      icon: (
        <div style={{ background: '#EFF8FF', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon chatFeature" />
        </div>
      ),
      title: 'Chat & Messaging',
      description: 'Real-time user to user & group chats.',
    },
    {
      key: 'calling',
      icon: (
        <div style={{ background: '#ECFDF3', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon callingFeature" />
        </div>
      ),
      title: 'Voice & Video Calling',
      description: 'In-app calling & conferencing',
    },
    {
      key: 'aiAgent',
      icon: (
        <div style={{ background: '#F4F3FF', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon aiAgentFeature" />
        </div>
      ),
      title: 'AI Agent',
      description: 'Full stack AI Agents for your app',
    },
    {
      key: 'moderation',
      icon: (
        <div style={{ background: '#FEF3F2', padding: '10px', borderRadius: '8px' }}>
          <div className="featuresIcon moderationFeature" />
        </div>
      ),
      title: 'AI Moderation',
      description: 'Safeguard against harmful content',
    },
  ]

  return (
    <div className="chooseFeatureWrapper">
      <div className="chooseFeature">
        <div className="chooseFeatureHeader">
          <div className="chooseFeatureTitle">Select Your Product</div>
          <div className="chooseFeatureSubtitle">
            Choose the products you would like to begin with. Additional products can be integrated
            at any time.
          </div>
        </div>

        <div className="featuresContainer">
          {features.map(f => {
            const isSelected = selectedFeatures.includes(f.key)
            return (
              <div
                key={f.key}
                className={`feature-card ${isSelected ? 'selected' : ''}`}
                role="button"
                tabIndex={0}
                onClick={() => toggleSelect(f.key)}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault()
                    toggleSelect(f.key)
                  }
                }}
                aria-pressed={isSelected}
              >
                <div className="feature-left">
                  {f.icon}
                  <div>
                    <div className="feature-title">{f.title}</div>
                    <div className="feature-description">{f.description}</div>
                  </div>
                </div>
                <div className={`feature-checkbox ${isSelected ? 'checked' : ''}`}>
                  {isSelected && <CheckOutlined style={{ color: 'white', fontSize: 12 }} />}
                </div>
              </div>
            )
          })}
        </div>
        <Form.Item
          name="features"
          rules={[{ required: true, message: 'Please select at least one product to continue' }]}
          initialValue={selectedFeatures}
          style={{ margin: '0px' }}
        >
          <Input type="hidden" style={{ minHeight: '0px', border: '2px solid green' }} />
        </Form.Item>

        <ButtonBlack
          buttonStyles={{
            width: '100%',
            height: '44px',
            marginTop: '5px',
            fontSize: '16px',
          }}
          holderStyles={{ width: '100%' }}
          buttonText="Continue"
          onClick={handleContinue}
        />
      </div>
    </div>
  )
}

export default StepChooseFeatures
